import { ConfigType } from 'dayjs';
import { isAfter } from './isAfter';

export const sortDate = <T extends ConfigType>(dateList: T[]): T[] =>
  dateList.sort((a, b) => (isAfter(a, b) ? 1 : -1));
